module.exports = __webpack_public_path__ + "img/iteration-FP.ddec9411.png";